import { StyleSheet } from 'aphrodite';
import { scrollbarBase } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	center: {
		justifyContent: 'center',
		alignItems: 'center',
	},
	fullHeight: {
		height: '100%',
	},
	fullWidth: {
		width: '100%',
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		overflow: 'hidden',
		boxSizing: 'border-box',
	},
	column: {
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		boxSizing: 'border-box',
	},
	scrollable: {
		overflowX: 'hidden',
		overflowY: 'auto',
		...scrollbarBase,
	},
	page: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		padding: '0 24px',
	},
});
